module.exports = __webpack_public_path__ + "media/src/images/logos/facebook-f-logo-5473cef43d3c41f619b79f0a539da968.png";